export default __webpack_public_path__ + "static/media/labeldat4.d903c6ab.png";